const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
const SLOTS = ['Morning (6-12)', 'Afternoon (12-17)', 'Evening (17-21)', 'Night (21-24)'];

const AvailabilityPicker = ({ availability, onChange }) => {
  const getDay = (day) => availability.find(a => a.day === day) || { day, slots: [] };

  const toggleSlot = (day, slot) => {
    const existing = getDay(day);
    const hasSlot = existing.slots.includes(slot);
    const newSlots = hasSlot ? existing.slots.filter(s => s !== slot) : [...existing.slots, slot];
    const rest = availability.filter(a => a.day !== day);
    if (newSlots.length === 0) {
      onChange(rest);
    } else {
      onChange([...rest, { day, slots: newSlots }]);
    }
  };

  return (
    <div className="form-group">
      <label className="form-label">Availability</label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: 14, background: 'var(--gray-50)', borderRadius: 'var(--radius-sm)', border: '1.5px solid var(--gray-200)' }}>
        {DAYS.map(day => {
          const dayData = getDay(day);
          return (
            <div key={day} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ fontSize: 13, fontWeight: 500, color: 'var(--gray-600)', width: 90, flexShrink: 0 }}>
                {day.slice(0, 3)}
              </span>
              <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                {SLOTS.map(slot => {
                  const active = dayData.slots.includes(slot);
                  return (
                    <button
                      key={slot}
                      type="button"
                      onClick={() => toggleSlot(day, slot)}
                      style={{
                        padding: '4px 10px',
                        borderRadius: 999,
                        border: `1.5px solid ${active ? 'var(--primary)' : 'var(--gray-200)'}`,
                        background: active ? 'var(--primary-light)' : 'var(--white)',
                        color: active ? 'var(--primary-dark)' : 'var(--gray-500)',
                        fontSize: 12,
                        fontWeight: 500,
                        cursor: 'pointer',
                        transition: 'all 0.15s',
                      }}
                    >
                      {slot.split(' ')[0]}
                    </button>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
      <span className="form-hint">Select your available time slots</span>
    </div>
  );
};

export default AvailabilityPicker;
